import { render, staticRenderFns } from "./songsListsDetail.vue?vue&type=template&id=1d0b49de&scoped=true&"
import script from "./songsListsDetail.vue?vue&type=script&lang=js&"
export * from "./songsListsDetail.vue?vue&type=script&lang=js&"
import style0 from "./songsListsDetail.vue?vue&type=style&index=0&id=1d0b49de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0b49de",
  null
  
)

export default component.exports